import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotateRight, faSpinner, faXmark } from '@fortawesome/free-solid-svg-icons';

import { TertiaryButton } from '@/components/button/Button.jsx';
import { TONE_ICONS } from '@/components/status-pill/statusTones.js';

import './StatusBanner.css';

const cx = (...parts) => parts.filter(Boolean).join(' ');

const StatusBanner = ({
    status = 'danger',
    header,
    subheader,
    icon = true,
    // Something is running: a spinning icon and a bar running along the foot, until the banner goes.
    busy = false,
    action,
    onRetry,
    onClose,
    children,
}) => {
    const glyph = busy ? faSpinner : (icon === true ? TONE_ICONS[status] : icon);

    return (
        <div
            className={cx('status-banner', status !== 'info' && `status-banner--${status}`, busy && 'status-banner--busy')}
            role={status === 'danger' || status === 'warning' ? 'alert' : 'status'}
            aria-busy={busy || undefined}
        >
            {glyph && <FontAwesomeIcon icon={glyph} spin={busy} className="status-banner-icon" />}
            <div className="status-banner-content">
                {header && <span className="status-banner-header">{header}</span>}
                {subheader && <span className="status-banner-subheader">{subheader}</span>}
                {children}
            </div>
            {action && <div className="status-banner-action">{action}</div>}
            {onRetry && (
                <TertiaryButton
                    status={status}
                    icon={faRotateRight}
                    aria-label="Retry"
                    onClick={onRetry}
                />
            )}
            {onClose && (
                <TertiaryButton
                    status={status}
                    icon={faXmark}
                    aria-label="Dismiss"
                    onClick={onClose}
                />
            )}
        </div>
    );
};

export default StatusBanner;
